import { Directive, inject, Input, TemplateRef, ViewContainerRef } from '@angular/core'
import { Store } from '@ngrx/store'
import { selectUserPermissions } from '../store/auth/auth.selectors'
import { AuthState } from '../store/auth/auth.state'
import { take } from 'rxjs'

@Directive({
  selector: '[appHasPermission]',
  standalone: true
})
export class HasPermissionDirective {
  private store = inject(Store)
  private userPermissions$ = this.store.select(selectUserPermissions)

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef
  ) {}

  @Input('appHasPermission') set hasPermission(
    requiredPermissions: Record<string, string[]> | Record<string, string[]>[]
  ) {
    this.userPermissions$.pipe(take(1)).subscribe(userPermissions => {
      const permissions = userPermissions as Record<string, string[]>
      const required = Array.isArray(requiredPermissions)
        ? requiredPermissions
        : [requiredPermissions]
      this.updateView(permissions, required)
    })
  }

  private updateView(
    userPermissions: NonNullable<AuthState['user']>['userRole']['permissions'],
    requiredPermissionsArray: Record<string, string[]>[]
  ) {
    const hasPermission = requiredPermissionsArray.some(requiredPermission =>
      Object.entries(requiredPermission).every(([entity, actions]) =>
        actions.every(action => userPermissions[entity]?.includes(action))
      )
    )

    if (hasPermission) {
      if (this.viewContainer.length === 0) {
        this.viewContainer.createEmbeddedView(this.templateRef)
      }
    } else {
      this.viewContainer.clear()
    }
  }
}
